/** @jsx jsx */
import { Global, jsx } from '@emotion/core';
import { ThemeProvider } from '@material-ui/core';
import * as Sentry from '@sentry/browser';
import { mainStyles } from 'main.style';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { theme } from 'theme';
import { checkVersion } from 'utils/checkVersion';
import { getEnvironment } from 'utils/handlers/envHandler';
import { initTranslation } from 'utils/initTranslation';
import App from './App';
import * as serviceWorker from './serviceWorker';
import store from './store';

Sentry.init({
  dsn: getEnvironment('REACT_APP_SENTRY_DSN'),
  environment: process.env.NODE_ENV,
});

async function render(): Promise<void> {
  await checkVersion();

  initTranslation();

  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <Global styles={mainStyles} />
          <App />
        </ThemeProvider>
      </Provider>
    </React.StrictMode>,
    document.getElementById('root'),
  );
}

document.addEventListener('DOMContentLoaded', render);
